// extracted by mini-css-extract-plugin
export default {"menuContainer":"TaxonomyDetailsAuditTokens_menuContainer__WqHCS","containerSearch":"TaxonomyDetailsAuditTokens_containerSearch__LNjuA"};